<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span>每日体检费用 <small>(合计：¥{{ total }}元)</small></span>
            <el-form :inline="true" :model="form" style="float:right">
                <!-- <el-form-item label="预约日期">
                    <el-date-picker v-model="form.daterange" size="mini" type="daterange" range-separator="至"
                    style="width: 240px"
                        start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item> -->
                <el-button style="padding: 3px 0" type="text" @click="getData" icon="el-icon-refresh"></el-button>
            </el-form>
        </div>
        <v-chart autoresize ref="chart" :option="option" style="height: 200px" v-loading="loading"></v-chart>
    </el-card>
</template>

<script>
export default {
    name: 'statAppointFeeDates',
    props: {
        search: {
            type: [Object],
            default: () => { }
        }
    },
    data() {
        return {
            loading: false,
            form: { daterange: [] },
            total: 0,
            option: {
                grid: {
                    top: 20,
                    bottom: 20,
                    left: 70,
                    right: 15
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}元'
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        color: '#1890ff',
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            color: 'black',
                            fontSize: 12
                        }
                    }
                ]
            }

        }
    },
    methods: {
        money(value) {
            if (parseFloat(value).toString() == 'NaN') return '0.0'
            var intPart = Number(value).toFixed(0) //获取整数部分
            var intPartFormat = intPart
                .toString()
                .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
            var floatPart = '.00' //预定义小数部分
            var value2Array = value.split('.')
            //=2表示数据有小数位
            if (value2Array.length == 2) {
                floatPart = value2Array[1].toString() //拿到小数部分
                if (floatPart.length == 1) {
                    //补0,
                    return intPartFormat + '.' + floatPart + '0'
                } else {
                    return intPartFormat + '.' + floatPart
                }
            } else {
                return intPartFormat + floatPart
            }
        },
        async getData() {
            this.loading = true
            const resp = await this.$http.get('/components/charts/statistics/appoint/renshudates', { params: this.search })
            this.option.xAxis.data = []
            this.option.series[0].data = []
            this.total = 0
            resp.data.forEach(e => {
                this.option.xAxis.data.push(e.name.slice(5))
                this.option.series[0].data.push(parseFloat(e.fee_total))
                this.total += parseFloat(e.fee_total)
            })
            this.total = this.money(this.total.toFixed(2))
            this.$refs['chart'].setOption(this.option)
            this.loading = false
        }
    },
    mounted() {
        this.getData().then(() => {
        })
    }
}
</script>
